module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/10-90d965c85b2f6f9d0fa1a5b134b6e75d.png";